'use strict';

var scrollAnimate = require('./scrollAnimate');

/**
 * appends params to a url
 * @param {Element} $this - current form
 * @param {string} data - data returned from the server's ajax call
 */
function displayMessage($this, data) {
    $.spinner().stop();
    $($this).find('.js-invalid-feedback').removeClass('d-block');
    if (data?.success && data?.renderedTemplate) {
        $('.footer-newsletter-section').find('.footer-heading').addClass('d-none');
        $($this).find('.form-group').removeClass('d-flex').addClass('d-none');
        $($this).find('.email-signup-msg').html(data.renderedTemplate);
        $($this).find('.email-signup-msg').removeClass('d-none');
    } else {
        $($this).find('.email-signup-msg').empty();
        $($this).find('.js-invalid-feedback').html(data.msg);
        $($this).find('.js-invalid-feedback').addClass('d-block');
        $($this).find('.email-signup-field').addClass('is-invalid');
    }
}

module.exports = function () {
    $('.back-to-top').click(function () {
        scrollAnimate();
    });

    $('.newsletter-form-js').on('submit', function (e) {
        e.preventDefault();
        var $this = $(this);
        $this?.find('input[name=brandName]').val($('.header')?.find('.logo-home')?.find('.logo-img')?.data('brand'));
        $.spinner().start();
        $(this).attr('disabled', true);
        $.ajax({
            url: $this.attr('action'),
            type: 'post',
            dataType: 'json',
            data: $this.serialize(),
            success: function (data) {
                displayMessage($this, data);
                // Send event for data layer
                if (data?.success) {
                    $('body').trigger('newsletter:subscribe', { success: true, source: 'footer' });
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};
